export default __webpack_public_path__ + "static/media/usdc.46b817da.svg";